import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { totalBonusAmount } from 'tools/wallet'
import Gift from 'images/icons/Gift'

const BonusLabel = styled.div`
  font-size: 14px;
  color: #FFF;
  text-shadow: 1px 1px rgb(0,0,0,.1);
`

const GiftWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 6px;

    span {
      background: transparent;
      border: none;
    }
    svg {
      height: 16px;
      width:auto;
      padding-right: 8px
    }
`

function BonusBalance (props) {
  const { bonusArry } = props
  const bonus = totalBonusAmount(bonusArry)
  const formattedBonus = bonus.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })

  return (
    <BonusLabel>
      <GiftWrapper>
        <Gift/>
        {
          formattedBonus === null &&
          <span>...</span>
        }
        {
          formattedBonus &&
          <span>{formattedBonus}</span>
        }
      </GiftWrapper>
    </BonusLabel>
  )
}

BonusBalance.propTypes = {
  bonusArry: PropTypes.array,
}

export default BonusBalance



// WEBPACK FOOTER //
// ./src/atoms/BonusBalance/BonusBalance.js